import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {

  public staticData:any='';
  public loading :boolean=false;
  public currentUrl:any=this.router.url;

  constructor(public router: Router, public service: GlobalService) {
    this.getContent();
   }

   getContent(){
    this.loading=true;
    var url='';
    if(this.currentUrl=='/about-us'){
      url='/master/about-us';
    } else if(this.currentUrl=='/term-condition'){
      url='/master/term-condition';
    } else{
      url='/master/privacy-policy';
    }
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success==1){
        this.staticData =response.data;
        this.loading=false;
      } else {
        this.loading=false;
      }
    }))
  }

}
